import React from 'react';

// Horizontal section tabs for the help drawer.
export default function HelpNav({ sections, activeSection, onSectionChange }) {
  return (
    <div className="help-nav d-flex border-bottom overflow-auto" role="tablist">
      {sections.map((s) => {
        const active = s.id === activeSection;
        return (
          <button
            key={s.id}
            type="button"
            role="tab"
            aria-selected={active}
            className={`help-nav-tab d-flex align-items-center gap-2 flex-shrink-0${active ? ' active' : ''}`}
            onClick={() => onSectionChange(s.id)}
          >
            <i className={s.icon} aria-hidden="true" />
            <span>{s.title}</span>
          </button>
        );
      })}
    </div>
  );
}
